module.exports = __webpack_public_path__ + "static/media/java.1448ac85.jpg";